<template><profit-loss-document-page direction="profit" /></template>
<script>
import ProfitLossDocumentPage from '../profitloss/ProfitLossDocumentPage'
export default { name: 'ErpStockProfit', components: { ProfitLossDocumentPage } }
</script>
